import resetDecisions from './ResetDecisions';

export default resetDecisions;
